import React from "react";

export default function ProductFilterSidebar({
  categories,
  subCategories,
  selectedFilters,
  setSelectedFilters,
}) {
  const selectProductType = (type) => {
    setSelectedFilters((prev) => ({
      ...prev,
      productType: type,

      // IMPORTANT
      // Reset old Security/IT selections
      category: "",
      subCategory: "",
    }));
  };

  const selectCategory = (id) => {
    setSelectedFilters((prev) => ({
      ...prev,
      category: prev.category === id ? "" : id,
      subCategory: "",
    }));
  };

  const selectSubCategory = (id) => {
    setSelectedFilters((prev) => ({
      ...prev,
      subCategory: prev.subCategory === id ? "" : id,
    }));
  };

  const categoryLabel = (category) =>
    (
      category.name ||
      category.categoryName ||
      category.title ||
      "Category"
    ).toUpperCase();

  const subCategoryLabel = (subCategory) =>
    (
      subCategory.name ||
      subCategory.subCategoryName ||
      subCategory.title ||
      "Sub Category"
    ).toUpperCase();

  const activeStyle = "bg-blue-600 text-white shadow-md";

  const normalStyle = "bg-slate-100 text-slate-700 hover:bg-slate-200";

  const buttonClass = (active) =>
    `
    rounded
    transition-all
    duration-200
    font-medium
    px-3
    py-1.5
    text-[10px]
    sm:px-4
    sm:py-2
    sm:text-[12px]
    lg:px-5
    lg:py-2.5
    2xl:px-6
    2xl:py-3
    ${active ? activeStyle : normalStyle}
    `;

  const buttonClasstwo = (active) =>
    `
  rounded-md
  transition-all
  duration-200
  font-semibold

  min-w-[160px]
  text-center

  px-5
  py-2.5
  text-sm

  sm:min-w-[180px]
  sm:px-6
  sm:py-2
  sm:text-base

  lg:min-w-[190px]
  lg:px-7
  lg:py-2

  2xl:min-w-[210px]
  2xl:px-8
  2xl:py-3.5
  2xl:text-lg

  ${active ? activeStyle : normalStyle}
  `;

  return (
    <div
      className="
        space-y-5
        md:space-y-7
      "
    >
      {/* PRODUCT TYPE */}

      <div>
        <h4
          className="
            text-xs
            md:text-sm
            font-bold
            uppercase
            tracking-wide
            text-slate-700
            mb-3
          "
        >
          Product Type
        </h4>

        <div className="flex flex-wrap gap-2 md:gap-3">
          <button
            onClick={() => selectProductType("security")}
            className={buttonClasstwo(
              selectedFilters.productType === "security",
            )}
          >
            Security Products
          </button>

          <button
            onClick={() => selectProductType("it")}
            className={buttonClasstwo(selectedFilters.productType === "it")}
          >
            IT Products
          </button>
        </div>
      </div>

      {/* CATEGORIES */}

      <div>
        <h4
          className="
            text-xs
            md:text-sm
            font-bold
            uppercase
            tracking-wide
            text-slate-700
            mb-3
          "
        >
          Categories
        </h4>

        <div
          className="
            scrollbar-none
            max-h-48
            overflow-y-auto
            flex
            flex-wrap
            gap-2
            md:gap-3
          "
        >
          <button
            onClick={() => selectCategory("")}
            className={buttonClass(!selectedFilters.category)}
          >
            ALL CATEGORIES
          </button>
          {categories.map((cat) => (
            <button
              key={cat._id}
              onClick={() => selectCategory(cat._id)}
              className={buttonClass(selectedFilters.category === cat._id)}
            >
              {categoryLabel(cat)}
            </button>
          ))}
        </div>
      </div>

      {/* SUB CATEGORIES */}

      <div>
        <h4
          className="
            text-xs
            md:text-sm
            font-bold
            uppercase
            tracking-wide
            text-slate-700
            mb-3
          "
        >
          Sub Categories
        </h4>

        <div
          className="
            scrollbar-none
            max-h-64
            overflow-y-auto
            flex
            flex-wrap
            gap-2
            md:gap-3
          "
        >
          <button
            onClick={() => selectSubCategory("")}
            className={buttonClass(!selectedFilters.subCategory)}
          >
            ALL SUB CATEGORIES
          </button>

          {subCategories.map((subCat) => (
            <button
              key={subCat._id}
              onClick={() => selectSubCategory(subCat._id)}
              className={buttonClass(
                selectedFilters.subCategory === subCat._id,
              )}
            >
              {subCategoryLabel(subCat)}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
